<template>
  <div>
    <div class="card-sakali mb-0 p-2">
      <div class="card-subtitle pt-1"
           :class="{'text-danger': alertDeadline, 'text-muted': !alertDeadline}">
        {{ new Date(specialBet.deadline) | calendar }}
      </div>
      <div class="card-title mb-4">{{ specialBet.description }}</div>
      <!-- Tabelle mit Optionen -->
      <table class="w-100">
        <tr class="text-nowrap" :style="{cursor: (specialBet.open ? 'pointer' : 'not-allowed')}"
            :class="{'sakali-highlight': option.selected, 'text-muted': option.out}"
            v-for="option in specialBet.options"
            :key="option.name"
            @click="placeBet(specialBet.id, option.name)">
          <td v-if="specialBet.useEmblems" class="text-center p-0">
            <cld-image
                :public-id="'/sandkastenliga/realteams/' + teamId(option.name)"
                height="20"
                width="20"
                crop="fill"
                dpr="auto"/>
          </td>
          <td class="w-100 ps-1">{{ option.name }}</td>
          <td class="me-0">{{ option.quota | kies }}</td>
          <!-- Icon zur Anzeige, ob Tipp korrekt -->
          <td v-if="specialBet.finished || (option.out && option.selected)">
            <!-- korrektes Ergebnis - grüner Haken -->
            <span v-if="option.correct" class="text-success">
                                <fas icon="check" class="ms-1"></fas>
                        </span>
            <!-- falscher Tipp - rotes Kreuz -->
            <span v-if="option.selected && (!option.correct || option.out)" class="text-danger">
                                <fas icon="times" class="ms-1"></fas>
                        </span>
          </td>
        </tr>
      </table>
      <!-- Gewinner -->
      <div class="row mt-1 pt-2 border-top" v-if="winnersExpanded">
        <sakali-user
            v-for="winner in specialBet.winners"
            :key="winner.id"
            :user="winner"
            class="col-6 small"
            :class="{'text-sakali':loggedIn && (winner.id===user.id)}"/>
      </div>
    </div>
    <!-- Knopf zum Aufklappen der Gewinne -->
    <div v-if="specialBet.finished && specialBet.winners.length!==0"
         class="mt-0 d-flex justify-content-center">
      <div @click="winnersExpanded = !winnersExpanded" class="mt-0 px-2 bg-white small text-dark">Gewinner</div>
    </div>
  </div>
</template>

<script>
import sakaliApi from '../../sakali-api'
import {mapActions, mapGetters} from 'vuex'

export default {
  props: {
    specialBet: Object
  },
  data() {
    return {
      winnersExpanded: false,
      alertDeadline: false
    }
  },
  computed: {
    ...mapGetters(['user', 'loggedIn'])
  },
  methods: {
    ...mapActions(['handleErrorAction']),
    teamId(name) {
      return this.generateTeamIdFromName(name)
    },
    placeBet: function (specialBetId, option) {
      if (new Date(this.specialBet.deadline) < new Date().getTime()) {
        this.alertDeadline = true
        return
      }
      let payload = {
        name: option
      }
      sakaliApi.post('/specialbets/' + specialBetId + '/bet', payload).then((specialBet) => {
        this.$emit('update:special-bet', specialBet.data)
      }).catch(error => {
        this.handleErrorAction(error)
      })
    }
  }
}
</script>

<style scoped>
</style>
